import {
  Title,
  Value,
  HistoricalInfoContainer,
  HistoricalInfoContent,
  HistoricalInfoItem,
} from './styles';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from '@/hooks/useTranslation';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';
import { Link } from 'react-router-dom';

export interface HistoricalInfoProps {
  description: string;
  period?: string;
  source: string;
  width?: string;
  titleWidth?: string;
  titleMinWidth?: string;
  valueWidth?: string;
}

export const HistoricalInfo = ({
  description,
  period,
  source,
  width,
  titleWidth,
  titleMinWidth,
  valueWidth,
}: HistoricalInfoProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const hasLink = source?.includes('https://');

  return (
    <HistoricalInfoContainer width={width}>
      <HistoricalInfoContent>
        <HistoricalInfoItem>
          <Title
            variant="subtitle2"
            color="text.primary"
            width={titleWidth}
            minWidth={titleMinWidth}
          >
            <SafeMarkdown text={t('label.label.tooltip_description')} />
          </Title>

          <Value variant="subtitle2" color="text.primary" width={valueWidth}>
            <SafeMarkdown text={description} />
          </Value>
        </HistoricalInfoItem>

        {period && (
          <HistoricalInfoItem>
            <Title
              variant="subtitle2"
              color="text.primary"
              width={titleWidth}
              minWidth={titleMinWidth}
            >
              <SafeMarkdown text={t('label.label.tooltip_period')} />
            </Title>

            <Value variant="subtitle2" color="text.primary" width={valueWidth}>
              <SafeMarkdown text={period} />
            </Value>
          </HistoricalInfoItem>
        )}

        <HistoricalInfoItem>
          <Title
            variant="subtitle2"
            color="text.primary"
            width={titleWidth}
            minWidth={titleMinWidth}
          >
            <SafeMarkdown text={t('label.label.tooltip_source')} />
          </Title>

          {hasLink ? (
            <Link
              to={source}
              target="_blank"
              rel="noreferrer"
              style={{
                flex: 1,
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                color: theme.palette.info.main,
                textDecoration: 'underline',
                cursor: 'pointer',
                fontSize: theme.typography.body2.fontSize,
                fontWeight: 600,
              }}
            >
              <SafeMarkdown text={source} />
            </Link>
          ) : (
            <Value variant="subtitle2" color="text.primary" width={valueWidth}>
              <SafeMarkdown text={source} />
            </Value>
          )}
        </HistoricalInfoItem>
      </HistoricalInfoContent>
    </HistoricalInfoContainer>
  );
};
